module.exports = __webpack_public_path__ + "img/Bronze-Square.72366ec6.png";